import SFShuffleIcon from '@/component/icons/symbol/sf-shuffle-icon';
import SFTriceIcon from '@/component/icons/symbol/sf-trice-icon';

import EthIcon from '../icons/symbol/eth-icon';
import PolygonIcon from '../icons/symbol/polygon-icon';
import BnbIcon from '../icons/symbol/bnb-icon';
import sflErc20Abi from '@/lib/web3/abi/SflErc20abi.json';
import Erc20PolygonSflTrlabi from '@/lib/web3/abi/Erc20PolygonSflTrlabi.json';

import {
  COIN_NAME_SFL,
  COIN_NAME_TRI,
  TRI_CONTRACT,
  POLYGON_SHUFFLE,
  POLYGON_MAIN,
  POLYGON_AMOY,
  BNB_SMART_CHAIN,
  ETHER_MAIN,
  POLYGON_TRI,
  POLYGON_PRIVATE_TOKEN1,
  COIN_NAME_PRIVATE_TEST2,
  POLYGON_PRIVATE_TOKEN2,
  COIN_NAME_PRIVATE_TEST3,
  POLYGON_PRIVATE_TEST3,
  COIN_NAME_PRIVATE_TOKEN1,
} from '@/lib/common/name-space/';
// export const TRI_CONTRACT = process.env.REACT_APP_TRI_CONTRACT as string;

export type resNetworkList = {
  name: string;
  symbol: string;
  address: string;
  token: string | undefined;
  abi?: any[];
  icon: JSX.Element;
};
// ※ 체인을 추가 삭제 할 때마다 Chain.ts에서 네트워크관련 수정 필요
export default async function networkList(aChainId: number = POLYGON_MAIN): Promise<resNetworkList[]> {
  let re = null;
  switch (aChainId) {
    case 22023: // taycan
      re = await taycanList();
      break;
    case ETHER_MAIN: // eth
      re = await ethList();
      break;
    case POLYGON_MAIN: // polygon
      re = await polygonList();
      break;
    case POLYGON_AMOY:
      re = await polygonTestList();
      break;
    case BNB_SMART_CHAIN: // BNB Smart Chain
      re = await bnbSmartChain();
      break;
    // case 8217: // klaytn
    //   re = klaytnList();
    //   break;
    default:
      re = await polygonList();
      break;
  }
  return re;
}

const taycanList = () => [
  {
    name: '셔플',
    symbol: COIN_NAME_SFL,
    address: '',
    token: '',
    icon: <SFShuffleIcon />,
  },
  {
    name: '트라이스',
    symbol: COIN_NAME_TRI,
    address: '',
    token: TRI_CONTRACT,
    icon: <SFTriceIcon />,
  },
];

const ethList = () => [
  {
    name: '이더',
    symbol: 'ETH',
    address: '',
    token: '',
    icon: <EthIcon />,
  },
];
// 프라이빗 토큰 등록할 때
// 아래에 추가 및 privateToekns.ts 추가
const polygonList = () => [
  {
    name: '폴리곤',
    symbol: 'MATIC',
    address: '',
    token: undefined,
    icon: <PolygonIcon />,
  },
  // {
  //   name: '테더',
  //   symbol: 'USDT',
  //   address: '',
  //   token: POLYGON_USDT,
  //   icon: <TetherIcon />,
  // },
  {
    name: '셔플',
    symbol: COIN_NAME_SFL,
    address: '',
    token: POLYGON_SHUFFLE,
    abi: Erc20PolygonSflTrlabi,
    icon: <SFShuffleIcon />,
  },
  {
    name: '트라이스',
    symbol: COIN_NAME_TRI,
    address: '',
    token: POLYGON_TRI,
    abi: Erc20PolygonSflTrlabi,
    icon: <SFTriceIcon />,
  },
  // TODO private 토큰 추가해야 함

  // {
  //   name: '프라이빗1',
  //   symbol: COIN_NAME_PRIVATE_TOKEN1,
  //   address: '',
  //   token: POLYGON_PRIVATE_TOKEN1,
  //   abi: Erc20PolygonSflTrlabi,
  //   icon: <SFTriceIcon />,
  // },

  // {
  //   name: '프라이빗2',
  //   symbol: COIN_NAME_PRIVATE_TEST2,
  //   address: '',
  //   token: POLYGON_PRIVATE_TOKEN2,
  //   abi: Erc20PolygonSflTrlabi,
  //   icon: <SFTriceIcon />,
  // },

  {
    name: '프라이빗3',
    symbol: 'AIR1',
    address: '',
    token: '0x167b497d0e0FcbBE6Bd3F758878DE58BF6Afae86', // 토큰 컨트랙트
    abi: Erc20PolygonSflTrlabi,
    icon: <SFTriceIcon />,
  },

  {
    name: '프라이빗4',
    symbol: 'AIR2',
    address: '',
    token: '0x10F7938f0fAc0f66Aad1687Ca4065a4e19413495',
    abi: Erc20PolygonSflTrlabi,
    icon: <SFTriceIcon />,
  },

  {
    name: '프라이빗5',
    symbol: 'AIR3',
    address: '',
    token: '0x038EC18750d0C4290fcb3314f75f2fa3A91f5BB5',
    abi: Erc20PolygonSflTrlabi,
    icon: <SFTriceIcon />,
  },
  {
    name: '프라이빗6',
    symbol: 'CTF1',
    address: '',
    token: '0x7583f44B395Ccd3b98391D6200a506968f5BEe75',
    abi: Erc20PolygonSflTrlabi,
    icon: <SFTriceIcon />,
  },
  {
    name: '프라이빗7',
    symbol: 'test',
    address: '',
    token: '0x9Ad14B29Ca8E41aF0d9Da2bA9943d8a187563325',
    abi: Erc20PolygonSflTrlabi,
    icon: <SFTriceIcon />,
  },

  // {
  //   name: '프라이빗3',
  //   symbol: COIN_NAME_PRIVATE_TEST3,
  //   address: '',
  //   token: POLYGON_PRIVATE_TEST3,
  //   abi: Erc20PolygonSflTrlabi,
  //   icon: <SFTriceIcon />,
  // },

  // {
  //   name: '도지',
  //   symbol: 'EDOGE',
  //   address: '',
  //   token: POLYGON_EDOGE,
  //   icon: <TetherIcon />,
  // },
];

const polygonTestList = () => [
  {
    name: '폴리곤',
    symbol: 'MATIC',
    address: '',
    token: undefined,
    icon: <PolygonIcon />,
  },
  // {
  //   name: '테더',
  //   symbol: 'USDT',
  //   address: '',
  //   token: '0x41E94Eb019C0762f9Bfcf9Fb1E58725BfB0e7582',
  //   icon: <TetherIcon />,
  // },
  {
    name: '셔플',
    symbol: COIN_NAME_SFL,
    address: '',
    token: POLYGON_SHUFFLE,
    abi: sflErc20Abi,
    icon: <SFShuffleIcon />,
  },
  {
    name: '트라이스',
    symbol: COIN_NAME_TRI,
    address: '',
    token: POLYGON_TRI,
    abi: sflErc20Abi,
    icon: <SFTriceIcon />,
  },

  {
    name: '프라이빗1',
    symbol: COIN_NAME_PRIVATE_TOKEN1,
    address: '',
    token: POLYGON_PRIVATE_TOKEN1,
    abi: Erc20PolygonSflTrlabi,
    icon: <SFTriceIcon />,
  },

  {
    name: '프라이빗2',
    symbol: COIN_NAME_PRIVATE_TEST2,
    address: '',
    token: POLYGON_PRIVATE_TOKEN2,
    abi: Erc20PolygonSflTrlabi,
    icon: <SFTriceIcon />,
  },

  {
    name: '프라이빗3',
    symbol: COIN_NAME_PRIVATE_TEST3,
    address: '',
    token: POLYGON_PRIVATE_TEST3,
    abi: Erc20PolygonSflTrlabi,
    icon: <SFTriceIcon />,
  },
];
const bnbSmartChain = () => [
  {
    name: 'Bnb',
    symbol: 'BNB',
    address: '',
    token: undefined,
    icon: <BnbIcon />,
  },
];

